'use strict'

import Session from './session'

export default class RESTSession extends Session {
  constructor (opts) {
    super(opts)
  }
}
